import { calcGapX } from "../RapidNumbers.data";
import { DragAndDrop } from "../../../../components/global/DragAndDrop";
import { animationDurationToShowQuestion } from "../../../../config";
import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { CircleButton } from '../../../../components/elements/CircleButton';
import { getCircleComponent } from "../../../../hooks/useCircleButtonColor";
import '../../../style.css'


export const BottomPart = ({state, answers, refresh, selected, level}) => {
    const colors = useRef(getCircleComponent(answers));
    const [index, setIndex] = useState('');
    const [animate, setAnimate] = useState(false);

    const isDragging = useRef();

    useEffect(()=>{
        if (!animate) return;
        setAnimate(false);
        setIndex('');
        isDragging.current = false;
        colors.current = getCircleComponent(answers);
    }, [answers]);

    return (
        <div className={`dropAnswers rapidWidth flex items-center border-[3px] border-[#2F9EBA] bg-[#FFF] rounded-[16px] justify-evenly
                       ${state ? "bottompartIsStateHeight" : "bottompartIsNotStateHeight"}`}>
            {answers.map((answer, i)=>{
                if (index === i) {
                    return (
                        <DragAndDrop
                            key={answer} 
                            enableClick = {false}
                            cmp={"colors"} 
                            drop={"dropColor"}
                            item = {answer}
                            dragging = {(state)=>{
                                if (!state) return
                                isDragging.current = state;
                            }}
                            refresh={(sound, event) => {
                                setIndex('');
                                refresh(event, i, answer, '', isDragging.current)
                            }}
            
                        >
                            <div 
                                className={`z-[50] cursor-pointer
                                            ${state ? 'md:w-[39px] md:h-[39px] lg:w-[50px] lg:h-[50px] xl:w-[70px] xl:h-[70px] ' : ' md:w-[49px] md:h-[49px]  lg:w-[69px] lg:h-[69px] xl:w-[89px] xl:h-[89px] '} sm:w-[39px] sm:h-[39px] w-[30px] h-[30px]
                                            ${selected.includes(answer) ? "opacity-0" : "opacity-100"}
                                        `}
                            >
                                <CircleButton key={i} isActive={answer} color={colors.current[i]}>
                                     {answer}
                                </CircleButton>
                            </div>
                        </DragAndDrop>
                    )
                } else {
                    return (
                        <motion.div
                            animate={{y: animate ? [0, 0] : [(i+1)*500, 0]}}
                            transition={{duration: animationDurationToShowQuestion, type: "tween"}} 
                            onMouseEnter={(e)=>{
                                setIndex(i);
                                setAnimate(true);
                            }}
                            onTouchStart={(e)=>{
                                setIndex(i);
                                setAnimate(true);
                            }}
                           key={answer}
                           className={`z-[50] cursor-pointer
                                      ${state ? 'md:w-[39px] md:h-[39px] lg:w-[50px] lg:h-[50px] xl:w-[70px] xl:h-[70px] ' : ' md:w-[49px] md:h-[49px]  lg:w-[69px] lg:h-[69px] xl:w-[89px] xl:h-[89px] '} w-[39px] h-[39px]
                                      ${selected.includes(answer) ? "opacity-0" : "opacity-100"}
                                    `}
                        >
                                <CircleButton key={i} isActive={answer} color={colors.current[i]}>
                                     {answer}
                                </CircleButton>
                        </motion.div>
                    )
                }
            })}
        </div>
    )
}